import BootstrapOffcanvas from "react-bootstrap/Offcanvas";
import Image from "../Image";
import CloseButton from "../CloseButton";
import Button from "../Button";

function OffcanvasHeader({ title, closeButton, onHide, onGoBack, goBackButton }) {
  return (
    <BootstrapOffcanvas.Header>
      {goBackButton ? (
        <Button
          variant="ghost-dark"
          leftIconName="chevron-left"
          onClick={onGoBack}
        />
      ) : (
        <div className="p-3 m-1" />
      )}

      {title ? (
        <p className="text-center mb-0">{title}</p>
      ) : (
        <a href="/home">
          <Image
            src="logo"
            alt="logo"
            style={{ height: "16px" }}
          />
        </a>
      )}

      {closeButton && <CloseButton onClick={onHide} />}
    </BootstrapOffcanvas.Header>
  );
}

export default OffcanvasHeader;
